export default __webpack_public_path__ + "static/media/Frame.a90a5d37.png";